import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminContentCampaignService } from '@/modules/content-campaign/services/admin-content-campaign.service'
import { ContentCampaignUpdateAttributesRequestModel } from '@/modules/content-campaign/models/content-campaign-request.model'

@vservice()
export class ContentCampaignUpdateAttributesUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminContentCampaignService
  ) {
  }

  isLoading = false
  isSuccess = false

  execute(contentCampaignI: number, data: ContentCampaignUpdateAttributesRequestModel) {
    return this.service.update(contentCampaignI, data)
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }
}
